import React from 'react';
import { Button } from 'react-bootstrap';
import { faCopy, faPencil, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './AlertListRowOverlay.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  deleteSingleAlert,
  selectSingleAlertCrudOperation,
  selectSingleAlertCrudStatus,
} from '../../../redux/slices/singleAlertSlice/singleAlertSlice';
import DeleteConfirmationModal from '../../common/DeleteConfirmationModal';
import { CrudStatus } from '../../../utility/types/CrudStatus';
import { CrudType } from '../../../utility/types/CrudType';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';
import { loadAlertForClone } from '../../../redux/slices/alertFormSlice/alertFormSlice';

/* istanbul ignore next */
function AlertListRowOverlay({
  alertId, alertName, setModalJSX,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const crudStatus = useSelector(selectSingleAlertCrudStatus);
  const operation = useSelector(selectSingleAlertCrudOperation);
  const deleteInProgress = crudStatus === CrudStatus.PENDING && operation === CrudType.DELETE;

  const onClone = async (id) => {
    await dispatch(loadAlertForClone({ alertId: id })).unwrap();
    history.push('/s/alerts/new');
  };

  return (
    <div className="row-popover-content" style={{ backgroundColor: 'rgba(242, 242, 242, 1.0)' }}>
      <Button
        variant="link"
        className="text-muted"
        onClick={() => history.push(`/s/alerts/${alertId}/edit`)}
        title="Edit Alert"
      >
        <FontAwesomeIcon icon={faPencil} />
      </Button>
      <Button variant="link" className="text-muted" onClick={() => onClone(alertId)} title="Clone Alert">
        <FontAwesomeIcon icon={faCopy} />
      </Button>
      <Button
        variant="link"
        className="text-muted"
        title="Delete Alert"
        onClick={() => setModalJSX(
          <DeleteConfirmationModal
            itemName={alertName}
            handleDelete={() => {
              dispatch(deleteSingleAlert({ alertId }));
              setModalJSX(<></>);
            }}
            isButtonDisabled={deleteInProgress}
          />,
        )}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Button>
    </div>
  );
}

AlertListRowOverlay.propTypes = {
  alertId: PropTypes.number.isRequired,
  alertName: PropTypes.string.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};
export default connectModalContainerContextToComponent(AlertListRowOverlay);
